import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { branch, renderNothing, compose, defaultProps } from 'recompose';
import { BannerContainer, CloseButton, StrongText, Header, Body, LinkToFreeTrail } from './style';
import { sizes } from '../../../Utils/mediaQueries';
import { getCurrentWindowWidth } from '../../../Utils';
//ui
import { Text } from '../../UI/Text';
import { HoverableLink } from '../../Layouts';

const _BannerContentDefaultProps = {
    title: 'Join Tona today',
    text: "Tona boosts engagement and retention rates with leaderboards on your gym wall and on your member's phones",
    linkLabel: 'Sign up for free trial',
    linkUrl: {
        pathname: 'https://www.tona.fit/beta',
    },
};

const Button = ({ onClick, ...props }) => <CloseButton onClick={onClick}>x</CloseButton>;

function BannerContent({ title, text, linkUrl, linkLabel, onClose }) {
    return (
        <BannerContainer>
            <Header>
                <Button onClick={onClose} />
            </Header>
            <Body>
                <Text>
                    <StrongText>{title}</StrongText>
                    {text}
                </Text>
                <HoverableLink target={'_blank'} to={linkUrl}>
                    <LinkToFreeTrail>{linkLabel}</LinkToFreeTrail>
                </HoverableLink>
            </Body>
        </BannerContainer>
    );
}

const isBannerContentOpened = ({ isOpened, ...props }) => !isOpened;

BannerContent = compose(
    defaultProps(_BannerContentDefaultProps),
    branch(isBannerContentOpened, renderNothing),
)(BannerContent);

const bodyDOMNode = document.querySelector('body');

function renderInPortal(Component, props, container) {
    return createPortal(<Component {...props} />, container);
}

export class Banner extends PureComponent {
    constructor(props) {
        super(props);

        this.wrapper = document.createElement('div');
        this.wrapper.setAttribute('id', 'banner');

        this.state = {
            isOpened: true,
            windowWidth: 0,
            meta: { isOpenedModified: false },
        };
    }

    handleCloseBannerBlock = event => {
        this.setState(prevState => {
            return {
                ...prevState,
                isOpened: false,
                meta: {
                    isOpenedModified: true,
                },
            };
        });
    };

    componentDidMount() {
        bodyDOMNode.appendChild(this.wrapper);
        const windowWidth = getCurrentWindowWidth();

        this.setState(prevState => {
            const _updatedState = Object.assign({}, prevState);

            if (prevState.windowWidth === 0 && windowWidth > 0) {
                _updatedState['windowWidth'] = windowWidth;
            }

            if (windowWidth > sizes.tablet) {
                _updatedState['isOpened'] = false;
            } else {
                _updatedState['isOpened'] = true;
            }

            return _updatedState;
        });

        window.addEventListener('resize', this._updateWindowWidthState);
    }

    _updateWindowWidthState = event => {
        const newWindowWidth = getCurrentWindowWidth();
        this.setState(prevState => {
            if (newWindowWidth !== prevState.windowWidth) {
                return {
                    ...prevState,
                    windowWidth: newWindowWidth,
                };
            } else {
                return null;
            }
        });
    };

    _propsForChildren = () => ({
        isOpened: this.state.isOpened,
        onClose: this.handleCloseBannerBlock,
    });

    render() {
        return renderInPortal(BannerContent, this._propsForChildren(), this.wrapper);
    }

    componentDidUpdate(prevState, prevProps, snapshot) {
        const isTabletDevice = this.state.windowWidth < sizes.tablet;

        if (isTabletDevice && !this.state.meta.isOpenedModified) {
            this.setState({ isOpened: true });
        } else if (!isTabletDevice) {
            this.setState({ isOpened: false });
        }
    }

    componentWillUnmount() {
        bodyDOMNode.removeChild(this.wrapper);
        window.removeEventListener('resize', this._updateWindowWidthState);
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Banner/Banner.js